import {cardTitle} from "assets/jss/material-dashboard-pro-react.jsx";
import {specialScrollbar} from "assets/jss/special-scrollbar.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";

const mensagensStyle = {
  cardTitle,
  ...buttonStyle,
  ...customSelectStyle,
  modalCardTitle: {
    fontSize: "23px",
    position: "relative",
    top: "5px",
    left: "10px"
  },
  addForm: {
    padding: "0 10px"
  },
  mensagensContainerWrapper: {
    overflowX: "auto",
    margin: "0 -30px 5px -30px",
    padding: "0 30px 5px 30px",
    ...specialScrollbar
  },
  mensagensContainer: {
    display: "inline-flex",
    minWidth: "1000px",
    width: "100%"
  },
  sidebarCard: {
    minWidth: "190px",
    width: "190px",
    height: "185px",
    marginTop: 0,
    marginRight: "10px"
  },
  mensagensListaCard: {
    display: "inline-block",
    width: "380px",
    minWidth: "380px",
    minHeight: "500px",
    height: "calc(100vh - 250px)",
    margin: "0 10px 0 0",
    overflow: "auto",
    ...specialScrollbar
  },
  detalhesCard: {
    display: "inline-block",
    minHeight: "500px",
    margin: 0,
    height: "calc(100vh - 250px)"
  },
  sidebarCardBody: {
    padding: 0
  },
  sidebarUl: {
    listStyle: "none",
    padding: "10px 5px 10px 5px",
    margin: "0",
    "& > li": {
      margin: "10px",
      padding: "8px 0 5px 10px",
      borderRadius: "5px",
      position: "relative",
      cursor: "pointer",
      "& > svg": {
        marginTop: "1px",
      },
      "& > span": {
        marginLeft: "5px",
        position: "absolute",
        top: "11px"
      },
      "&:hover": {
        backgroundColor: "whitesmoke"
      },
      "&:active,&.active": {
        background: "linear-gradient(60deg,#009344,#38B449)",
        color: "white"
      }
    }
  },
  listaMensagensVazia: {
    textAlign: "center",
    display: "block",
    paddingTop: "10em"
  },
  wrapperMensagem: {
    padding: "10px 15px",
    borderBottom: "1px solid #eee",
    cursor: "pointer",
    "&.visto": {
      opacity: 0.85
    },
    "&:first-child": {
      borderRadius: "6px 6px 0 0",
    },
    "&:last-child": {
      marginBottom: "10px"
    },
    "&:hover": {
      backgroundColor: "#f9f9f9",
      opacity: 1
    },
    "&:active,&.active": {
      backgroundColor: "whitesmoke",
      opacity: 1
    }
  },
  mensagensListaCardBody: {
    padding: 0,
    backgroundColor: "white",
    minHeight: "100%",
    height: "fit-content"
  },
  mensagemAssunto: {
    fontSize: "16px",
    fontWeight: "400",
    width: "calc(100% - 15px)",
    display: "inline-block",
    marginRight: 0
  },
  mensagemBottom: {
    marginBottom: 0
  },
  mensagemTop: {
    position: "relative",
    "&>svg": {
      position: "absolute",
      top: "2px",
      right: "0",
      width: "0.7em!important",
      color: "#2AAEF5"
    }
  },
  mensagemData: {
    color: "gray",
    float: "right"
  },
  wrapperDetalhe: {
    padding: "15px 0",
    margin: "0 20px",
    borderBottom: "1px solid #eee"
  },
  detalheAssunto: {
    fontSize: "24px",
    fontWeight: "300",
    lineHeight: "1.2",
    width: "calc(100% - 57px)",
    display: "inline-block",
    marginRight: 0
  },
  detalheBottom: {
    marginTop: "20px",
    marginBottom: 0
  },
  detalheTop: {
    margin: "0 0 10px",
    position: "relative"
  },
  detalheNin: {
    color: "gray"
  },
  detalheDelete: {
    position: "absolute",
    top: "4px",
    right: "0",
    padding: "1px",
    cursor: "pointer",
    "&>svg": {
      width: "18px!important",
      fontSize: "17px",
      opacity: "0.5",
      "&:hover": {
        opacity: "1"
      }
    }
  },
  detalheResponder: {
    position: "absolute",
    top: "4px",
    right: "30px",
    padding: "1px",
    cursor: "pointer",
    "&>svg": {
      width: "18px!important",
      fontSize: "17px",
      opacity: "0.5",
      "&:hover": {
        opacity: "1"
      }
    }
  },
  detalheData: {
    color: "gray",
    float: "right"
  },
  detalheCorpo: {
    padding: "20px",
    overflow: "auto",
    ...specialScrollbar
  },
  detalheCorpoInner: {
    minHeight: "calc(100vh - 450px)"
  },
  detalhesCardBody: {
    padding: "0 0 20px 0",
    height: "100%",
    width: "100%"
  },
  buttonNovaMensagem: {
    position: "relative",
    height: "50px",
    width: "100%",
    display: "block",
    textAlign: "center",
    padding: "15px 10px",
    background: "linear-gradient(60deg,#009344,#38B449)",
    color: "white",
    cursor: "pointer",
    borderRadius: "6px 6px 0 0",
    "&:hover": {
      background: "linear-gradient(60deg,#008536,#208c23)"
    },
    "&:active": {
      background: "linear-gradient(60deg,#007530,#128f23)"
    },
    "&>svg": {
      position: "absolute",
      left: "25px"
    },
    "&>span": {
      position: "absolute",
      left: "55px",
      top: "16px"
    }
  },
  mensagemEditor: {
    minHeight: "85px",
    maxHeight: "300px",
    padding: 5,
    "& .public-DraftStyleDefault-block": {
      margin: "4px 0"
    }
  },
  mensagemToolbar: {}
};

export default mensagensStyle;
